/**
 * Regla de encendido y orden, compartidas por las cuatro superficies.
 *
 * Encendido: un grupo se pinta CON fotos si al menos una opción tiene foto Y
 * además el grupo cumple un piso de cobertura: tiene
 * `MAX_OPTIONS_WITHOUT_FLOOR` opciones o menos (ahí una sola foto ya se ve
 * bien), o al menos la mitad de sus opciones resuelven foto. Medido contra
 * producción: de 222 grupos fotografiables, 187 tienen 7 opciones o menos
 * — ahí la cobertura parcial se ve bien — pero 14 tienen 13 opciones o más
 * (toppings de pizza/hamburguesa), donde 1-2 fotos en una grilla de ~30
 * recuadros se ve peor que los chips. Si el grupo no enciende, se queda con
 * el render de texto de siempre — una grilla de tarjetas grandes mayormente
 * vacías ocupa el triple de pantalla y se ve peor que los chips de hoy.
 *
 * Orden: las que tienen foto primero, para que el hueco nunca quede en medio
 * de la grilla. Es estable, así que dentro de cada mitad no se altera nada.
 * No pisa configuración del dueño: `modifier_options.sort_order` no se
 * selecciona en ninguna de las dos queries de cliente (ver el spec §4.2).
 */

/**
 * Piso de tamaño bajo el cual una sola foto ya alcanza para encender el
 * grupo. Por encima de este tamaño, se exige además que al menos la mitad
 * de las opciones tengan foto. 187 de 222 grupos fotografiables en
 * producción tienen esta cantidad de opciones o menos; los 14 restantes
 * (13+ opciones, listas de toppings) son los que motivaron el piso.
 */
export const MAX_OPTIONS_WITHOUT_FLOOR = 7

export function groupShowsPhotos<T>(
  options: readonly T[],
  photoOf: (o: T) => string | null | undefined,
): boolean {
  const total = options.length
  if (total === 0) return false
  const conFoto = options.reduce((n, o) => n + (photoOf(o) ? 1 : 0), 0)
  if (conFoto === 0) return false
  if (total <= MAX_OPTIONS_WITHOUT_FLOOR) return true
  return conFoto * 2 >= total
}

export function orderOptionsByPhoto<T>(
  options: readonly T[],
  photoOf: (o: T) => string | null | undefined,
): T[] {
  const con: T[] = []
  const sin: T[] = []
  for (const o of options) (photoOf(o) ? con : sin).push(o)
  return [...con, ...sin]
}
